import { getApiClient } from '../../services/api/index';

export interface IUploadMediaPureUploadFileResponse {
  id: number;
  name: string;
  size: number;
  size_format: string;
  suffix: string;
  duration: number;
  duration_format: string;
  width: number;
  height: number;
  path: string;
  url: string;
  _t: number;
}

// 纯上传文件
export const postYouyanUploadMediaPureUploadFile = async (data: FormData) => {
  const client = await getApiClient();
  const response = await client.post<IUploadMediaPureUploadFileResponse>(
    '/youyan/upload_media/pure_upload_file/',
    data,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );
  return response.data;
};
